function initUpsellDropdowns() {
  const dropdowns = document.querySelectorAll(".m-upsell-dropdown-titlewrapper");

  dropdowns.forEach((dropdown) => {
    const content = dropdown.nextElementSibling;

    // Set default open state
    dropdown.classList.add("active");
    if (content && content.classList.contains("m-upsell-dd-content")) {
      content.style.maxHeight = content.scrollHeight + "px";
      content.style.opacity = "1";
    }

    // Add toggle event
    dropdown.addEventListener("click", function () {
      this.classList.toggle("active");

      if (content && content.classList.contains("m-upsell-dd-content")) {
        if (this.classList.contains("active")) {
          content.style.maxHeight = content.scrollHeight + "px";
          content.style.opacity = "1";
        } else {
          content.style.maxHeight = "0";
          content.style.opacity = "0";
        }
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () { const dropdowns = document.querySelectorAll(".m-upsell-dropdown-titlewrapper"); dropdowns.forEach((dropdown) => { const content = dropdown.nextElementSibling; dropdown.classList.add("active"); if (content && content.classList.contains("m-upsell-dd-content")) { content.style.maxHeight = content.scrollHeight + "px"; content.style.opacity = "1"; } dropdown.addEventListener("click", function () { this.classList.toggle("active"); if (content && content.classList.contains("m-upsell-dd-content")) { if (this.classList.contains("active")) { content.style.maxHeight = content.scrollHeight + "px"; content.style.opacity = "1"; } else { content.style.maxHeight = "0"; content.style.opacity = "0"; } } }); }); });